// | ------------------------------------------------------------------------
// | Parallax Sections
// | ------------------------------------------------------------------------ 


//? https://simpleparallax.com/
import simpleParallax from 'simple-parallax-js';


// | ------------------------------------------------------------------------


var image = document.getElementsByClassName('parallax-img');
new simpleParallax(image);